



























































































































































































  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import { Form as ElForm } from "element-ui";
  import { ruleNormal, rulePattern, hasPermission } from "../../../utils/common";
  // 引入sm3哈希算法
  import sm3 from 'sm3';
  //引入接口调用函数
import {
  getRegisterParam,
  registerTchInfo,
  registerUploadHeadUrl as buildRegisterAvatarUploadUrl
} from "../../../api/teacherRegister";

  @Component({
    name: "registered",
    components: {}
  })
  export default class Registered extends Vue {
  @Prop(String) type!: string;
  @Prop(Object) private teacherInfo!: {
    teacherName: "";
    teacherGenderId: "";
    teacherCard: "";
    teacherBirthday: "";
    teacherAge: "";
    teacherProfessionalId: "";
    teacherTeachingAge: "";
    teacherGradeId: "";
    teacherPhone: "";
    teacherSchoolId: "";
    teacherEmail: "";
    teacherAddress: "";
    tchLoginPwd: "";
    checkLoginPwd: "";
  };

    //页面参数
    private professionals: object[] = []; //职称数组
    private schools: object[] = [];//单位数组
    private districts: object[] = [];//市县
    private genders: object[] = [];//性别数组
    private grades: object[] = [];//年级数组
    private showTableLoading: boolean = false; //是否显示列表loading

    created() {
    //获取页面参数
    this.getParams();
    }

    private loading = false;
    private teacherLoginForm: any = {
      teacherCard: "",
      tchLoginPwd: "",
      checkLoginPwd: "",
      teacherName: "",
      teacherPhone: "",
      teacherGenderId: "",
      teacherBirthday: "",
      teacherAge: undefined,
      teacherProfessionalId: "",
      teacherDistrictId: "",
      teacherSchoolId: "",
      teacherGradeId: "",
      teacherTeachingAge: undefined,
      teacherEmail: "",
      teacherAddress: "",
      teacherPhotoPath: "",
      otherinfoHaveRelatives: "",
      otherinfoIntroduction: ""
    };

    get regAvatarUploadAction() {
      return buildRegisterAvatarUploadUrl();
    }

    get filteredSchools(): any[] {
      if (!this.teacherLoginForm.teacherDistrictId) {
        return this.schools as any[];
      }
      return (this.schools as any[]).filter(
        (s: any) => s.schoolDistrictId === this.teacherLoginForm.teacherDistrictId
      );
    }

    private handleDistrictChange() {
      this.teacherLoginForm.teacherSchoolId = "";
    }

    private beforeRegAvatarUpload(file: File) {
      const ok = file.type === "image/jpeg" || file.type === "image/jpg";
      if (!ok) {
        this.$message.error("仅支持 JPG 格式");
      }
      return ok;
    }

    private handleRegAvatarSuccess(res: any) {
      if (res.code !== "20000000") {
        this.$message.error(res.mesg || "上传失败");
        return;
      }
      const d = res.data || {};
      this.teacherLoginForm.teacherPhotoPath = d.path || d.teacherPhotoPath || "";
      this.$message.success("相片已上传");
    }

    // 校验两次密码一致
    private validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== (this.teacherLoginForm as any).tchLoginPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };


    private teacherLoginFormRules: object = {
      teacherPhone: [
      ruleNormal("请输入用户手机号"),
      rulePattern(/^1[3456789]\d{9}$/, "请输入正确的手机号码")],
      teacherCard:[
        ruleNormal("请输入身份证号")
      ],
      teacherName:[
        ruleNormal("请输入姓名")
      ],
      teacherGenderId:[
        ruleNormal("请选择性别")
      ],
      teacherBirthday:[
        ruleNormal("请选择出生年日")
      ],
      teacherAge:[
        ruleNormal("请输入年龄")
      ],
      teacherProfessionalId:[
        ruleNormal("请选择职称")
      ],
      teacherDistrictId:[
        ruleNormal("请选择所属市县")
      ],
      teacherSchoolId:[
        ruleNormal("请选择所属单位")
      ],
      teacherPhotoPath:[
        ruleNormal("请上传相片")
      ],
      otherinfoHaveRelatives:[
        ruleNormal("请选择利害关系")
      ],
      otherinfoIntroduction:[
        ruleNormal("请输入个人简历")
      ],
      teacherTeachingAge:[
        ruleNormal("请输入教龄")
      ],
      teacherEmail:[
        ruleNormal("请输入邮箱")
      ],
      teacherAddress:[
        ruleNormal("请输入地址")
      ],
      tchLoginPwd:[
        ruleNormal("请输入密码"),
        rulePattern(
        /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/,
        "密码长度8-30字符，必须包含字母、数字、特称字符"
      )
      ],
      checkLoginPwd:[
        ruleNormal("再次输入密码"),
         { validator: this.validatePass2, trigger: 'blur' }
      ]


    };



    get isTeacher () {
      return this.$route.name;
    }

    private registeredHandle() {
      (this.$refs.teacherLoginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          // 密码加密：仅SM3哈希，不再Base64
          const password = this.teacherLoginForm['tchLoginPwd']
          const convertPwd = sm3(password)
          let params = Object.assign({}, this.teacherLoginForm);
          params['tchLoginPwd'] = convertPwd
          await registerTchInfo(params);
          this.$message.success("保存成功");
          (this.$refs.teacherLoginForm as ElForm).clearValidate();
        } catch (error) {
          this.$message.error(error || "保存失败");
        }
      }
    });
    }

      //获取页面参数
  private async getParams() {
    try {
      let res = await getRegisterParam();
      this.schools = res.data.schools;
      this.districts = res.data.districts || [];
      this.genders = res.data.genders;
      this.professionals = res.data.professionals;
      this.grades = res.data.grades;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }


    private getToSchool() {
      this.$router.push({path: "/school"});
    }

    private goBack() {
      this.$router.push({ path: "/teacher" });
    }
  }
